<template>
  <div>
    {{ sortedTeamData }}
  </div>
  
</template>

<script>
import TwitchWrapper from '@/TwitchWrapper'
import sort from 'fast-sort'

export default {
  name: 'GenerateTeams',
  methods: {
    GenerateTeamData(){
      this.teams.forEach(t => {
        this.twitch.GetTeam(t).then(team => {
          this.teamData.push({
            name: team.name,
            title: team.display_name,
            logo: team.logo ? team.logo : '',
          })
        })
      })
    }
  },
  created () {
    this.GenerateTeamData()
  },
  computed: {
    sortedTeamData () {
      return sort(this.teamData).asc('name')
    }
  },
  data () {
    return {
      twitch: new TwitchWrapper(this.$root.$data.clientId),
      teamData: [],
      teams: ['athletico','corvidaeinc','jam','nzstreams','respawnninja','shaggynation','teamoce','womanz','shadecrew', 'mindfreak']
    };
  }
}
</script>